export const COLLECTION_PAGE_SIZE = 30;
